<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-header-image image="images/q8-header.jpg" />
      <o-section-header title="Pompnummer" />
      <o-section>
        <o-list-item
          icon="brands-q8"
          icon-style="logo"
          :no-padding="true"
          :chevron="false"
        >
          <template #label>
            Q8 Brusselsesteenweg<br />
            <span class="u-small u-muted">Brusselsesteenweg 100</span><br />
            <span class="u-small u-muted">3000 Leuven</span>
          </template>
        </o-list-item>
      </o-section>
      <o-section>
        <h2 class="u-title">Pomp 1</h2>
        <p>Kies je brandstof</p>
        <o-radio name="brandstof">Diesel - B7</o-radio>
        <o-radio name="brandstof">Benzine euro 95 - E10</o-radio>
        <o-radio name="brandstof">Benzine euro 98 - E5</o-radio>
      </o-section>
    </o-view>
    <o-pay-button label="Volgende" to="/sales/fuel/q8/fuel/confirmation" />
  </o-view>
</template>

<script>
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OPumpPicker from '@/components/OPumpPicker.vue'

export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OHeaderImage,
    OPayButton,
    OPumpPicker
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss"></style>
